<template>
  <div>
    <Header />
    <div id="fh5co-about" class="animate-box">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center fh5co-heading">
            <h2>About Me</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <ul class="info">
              <li>
                <span class="first-block">Full Name:</span
                ><span class="second-block">Desta Wiji Pratama</span>
              </li>
              <li>
                <span class="first-block">Email:</span
                ><span class="second-block">deswiji@gmail.com</span>
              </li>
              <li>
                <span class="first-block">Website Portfolio:</span
                ><span class="second-block"
                  ><a href="https://online-shop.destatama.my.id/"
                    >My Portfolio</a
                  ></span
                >
              </li>
              <li>
                <span class="first-block">Address:</span
                ><span class="second-block"
                  >Kecamatan Maja <br />Kabupaten Lebak<br />Provinsi
                  Banten</span
                >
              </li>
            </ul>
          </div>
          <div class="col-md-8">
            <h2>Hello There!</h2>
            <p>
              I specialize in software development, particularly website-based
              development. When building websites, I'm accustomed to using the
              JavaScript programming language from the frontend to the backend.
              I also use frameworks and libraries such as NodeJS, VueJS,
              ExpressJS, Bootstrap, and others. Beyond technical expertise, I'm
              also a meticulous person, persistent, and passionate about new
              technologies. I work as a developer for a company. In my free
              time, I enjoy cycling while listening to music. It makes me feel
              more relaxed and at ease.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div id="fh5co-resume" class="fh5co-bg-color">
      <div class="container">
        <div class="row animate-box">
          <div class="col-md-8 col-md-offset-2 text-center fh5co-heading">
            <h2>My Resume</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-md-offset-0">
            <ul class="timeline">
              <li class="timeline-heading text-center animate-box">
                <div><h3>Work Experience</h3></div>
              </li>
              <li class="animate-box timeline-unverted">
                <div class="timeline-badge"><i class="icon-suitcase"></i></div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <h3 class="timeline-title">NodeJS Developer</h3>
                    <span class="company"
                      >PT Bank SMBC Indonesia | 2024 - current</span
                    >
                  </div>
                  <div class="timeline-body">
                    <p></p>
                  </div>
                </div>
              </li>
              <li class="timeline-inverted animate-box">
                <div class="timeline-badge"><i class="icon-suitcase"></i></div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <h3 class="timeline-title">Backend Engineer</h3>
                    <span class="company">Kompas Gramedia | 2022 - 2024</span>
                  </div>
                  <div class="timeline-body">
                    <p></p>
                  </div>
                </div>
              </li>
              <li class="animate-box timeline-unverted">
                <div class="timeline-badge"><i class="icon-suitcase"></i></div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <h3 class="timeline-title">Web Developer</h3>
                    <span class="company"
                      >PT Indikom Megah Agung | 2022 - 2022</span
                    >
                  </div>
                  <div class="timeline-body">
                    <p></p>
                  </div>
                </div>
              </li>
              <li class="timeline-inverted animate-box">
                <div class="timeline-badge"><i class="icon-suitcase"></i></div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <h3 class="timeline-title">Technical Support</h3>
                    <span class="company"
                      >PT Telekomunikasi Seluler | 2020 - 2022</span
                    >
                  </div>
                  <div class="timeline-body">
                    <p></p>
                  </div>
                </div>
              </li>
              <li class="animate-box timeline-unverted">
                <div class="timeline-badge"><i class="icon-suitcase"></i></div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <h3 class="timeline-title">Warehouse Administrator</h3>
                    <span class="company"
                      >PT Mandala Adhiperkasa Sejati | 2018 - 2020</span
                    >
                  </div>
                  <div class="timeline-body">
                    <p></p>
                  </div>
                </div>
              </li>
              <br />
              <li class="timeline-heading text-center animate-box">
                <div><h3>Education</h3></div>
              </li>
              <li class="timeline-inverted animate-box">
                <div class="timeline-badge">
                  <i class="icon-graduation-cap"></i>
                </div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <h3 class="timeline-title">Bachelor Degree</h3>
                    <span class="company"
                      >Stikubank University | 2016 - 2020</span
                    >
                  </div>
                  <div class="timeline-body">
                    <p></p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- <div id="fh5co-features" class="animate-box">
      <div class="container">
        <div class="services-padding">
          <div class="row">
            <div class="col-md-8 col-md-offset-2 text-center fh5co-heading">
              <h2>My Services</h2>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 text-center">
              <div class="feature-left">
                <span class="icon">
                  <i class="icon-paintbrush"></i>
                </span>
                <div class="feature-copy">
                  <h3>Web Design</h3>
                  <p>
                    Facilis ipsum reprehenderit nemo molestias. Aut cum mollitia
                    reprehenderit.
                  </p>
                </div>
              </div>
            </div>

            <div class="col-md-4 text-center">
              <div class="feature-left">
                <span class="icon">
                  <i class="icon-briefcase"></i>
                </span>
                <div class="feature-copy">
                  <h3>Branding</h3>
                  <p>
                    Facilis ipsum reprehenderit nemo molestias. Aut cum mollitia
                    reprehenderit.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-4 text-center">
              <div class="feature-left">
                <span class="icon">
                  <i class="icon-search"></i>
                </span>
                <div class="feature-copy">
                  <h3>Analytics</h3>
                  <p>
                    Facilis ipsum reprehenderit nemo molestias. Aut cum mollitia
                    reprehenderit.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 text-center">
              <div class="feature-left">
                <span class="icon">
                  <i class="icon-bargraph"></i>
                </span>
                <div class="feature-copy">
                  <h3>Web Developent</h3>
                  <p>
                    Facilis ipsum reprehenderit nemo molestias. Aut cum mollitia
                    reprehenderit.
                  </p>
                </div>
              </div>
            </div>

            <div class="col-md-4 text-center">
              <div class="feature-left">
                <span class="icon">
                  <i class="icon-genius"></i>
                </span>
                <div class="feature-copy">
                  <h3>Web Marketing</h3>
                  <p>
                    Facilis ipsum reprehenderit nemo molestias. Aut cum mollitia
                    reprehenderit.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-4 text-center">
              <div class="feature-left">
                <span class="icon">
                  <i class="icon-chat"></i>
                </span>
                <div class="feature-copy">
                  <h3>Support</h3>
                  <p>
                    Facilis ipsum reprehenderit nemo molestias. Aut cum mollitia
                    reprehenderit.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <Footer />
  </div>
</template>

<script>
import Header from '../components/template/Header.vue';
import Footer from '../components/template/Footer.vue';
export default {
  name: 'mainSection',
  components: {
    Header,
    Footer,
  },
};
</script>
